import { Transition, Variants } from "motion/react";

/** Diameter (px) of the compact button a map legend collapses into. */
export const MAP_LEGEND_COLLAPSED_SIZE_PX = 40;

/** Collapse/expand crossfade — scales the legend in/out from its top corner. */
export const MAP_LEGEND_MOTION_VARIANTS: Variants = {
  initial: { opacity: 0, scale: 0.85 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.85 },
};

export const MAP_LEGEND_MOTION_TRANSITION: Transition = {
  type: "tween",
  duration: 0.18,
  ease: "easeOut",
};
